import { JsonPatchOperation } from "common/services/api/attorney-hub-api-service";
import LegalEntity from "legal-entities/entities/legal-entity/legal-entity";

export default class UpdateLegalEntityAPIRequest {
  payload: JsonPatchOperation[] = [];

  constructor(oldEntity: LegalEntity, newEntity: LegalEntity) {
    if (newEntity.name?.value !== oldEntity.name?.value) {
      this.payload.push({
        op: "replace",
        path: "/Name",
        value: newEntity.name?.value ?? null,
      });
    }

    const oldDomains = (oldEntity.emailDomains || []).map(d => d.value).sort();
    const newDomains = (newEntity.emailDomains || []).map(d => d.value).sort();
    if (JSON.stringify(oldDomains) !== JSON.stringify(newDomains)) {
      this.payload.push({
        op: "replace",
        path: "/EmailDomains",
        value: newDomains,
      });
    }
  }
}